import { SkeletonBlock } from '~/shared/ui'

export function LoadingSkeleton() {
  return (
    <div className="px-6 py-4">
      <div className="grid grid-cols-2 gap-6">
        <div className="flex flex-col gap-3">
          <SkeletonBlock className="h-5" />
          <SkeletonBlock className="h-[30px]" />
          <SkeletonBlock className="h-[100px]" />
        </div>
        <div className="flex flex-col gap-4">
          <SkeletonBlock className="h-5" />
          <SkeletonBlock className="h-[52px]" />
          <SkeletonBlock className="h-[52px]" />
          <SkeletonBlock className="h-[52px]" />
        </div>
      </div>
    </div>
  )
}
